import React from 'react';

import { ContainerSize } from '../components/Container';

/** @deprecated */
export type PageLayoutContextProps = {
  size: ContainerSize;
};

/** @deprecated */
export const PageLayoutContext = React.createContext<
  PageLayoutContextProps | undefined
>(undefined);

/** @deprecated */
export function usePageLayout() {
  const context = React.useContext(PageLayoutContext);

  if (context === undefined) {
    throw new Error(
      'Hook `usePageLayout` may only be used within a <PageLayout.Root />.'
    );
  }

  return context;
}

/** @deprecated */
export function usePageLayoutOptional(): Partial<PageLayoutContextProps> {
  return React.useContext(PageLayoutContext) || {};
}
